import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

function Settings({ tenantId }) {
  const [status, setStatus] = useState(null);
  const [loyalty, setLoyalty] = useState({ reward_type: 'discount_5', points_to_reward: 100, points_per_service: 20, is_enabled: true });
  const [agentConfig, setAgentConfig] = useState({
    persona_name: 'Sofia',
    system_prompt: 'Você é a Sofia, assistente inteligente da oficina mecânica. Seu objetivo é ajudar a agendar horários, cadastrar clientes e seus carros. Seja educada, simpática e objetiva.',
    welcome_message: 'Olá! Sou a Sofia, assistente inteligente da oficina. Como posso te ajudar hoje?',
    is_active: true,
    rag_content: ''
  });
  const [loading, setLoading] = useState(true);
  const [savingLoyalty, setSavingLoyalty] = useState(false);
  const [savingAgent, setSavingAgent] = useState(false);
  const [handovers, setHandovers] = useState([]);
  const [simMessages, setSimMessages] = useState([]);
  const [simInput, setSimInput] = useState('');
  const [simLoading, setSimLoading] = useState(false);
  const simPhone = '5511999999999';

  const formatMessageText = (text) => {
    if (!text) return '';
    // Converte trechos de **negrito** em tags <strong>
    const parts = text.split(/\*\*([^*]+)\*\*/g);
    return parts.map((part, idx) => {
      if (idx % 2 === 1) {
        return <strong key={idx}>{part}</strong>;
      }
      return part;
    });
  };

  useEffect(() => {
    fetchBillingStatus();
    fetchLoyaltySettings();
    fetchAgentConfig();
    fetchHandovers();
  }, [tenantId]);

  const fetchLoyaltySettings = async () => {
    try {
      const res = await apiFetch(`/loyalty/settings?tenant_id=${tenantId}`);
      const data = await res.json();
      setLoyalty(data);
    } catch (e) { console.error(e); }
  };

  const saveLoyalty = async () => {
    setSavingLoyalty(true);
    try {
      await apiFetch(`/loyalty/settings?tenant_id=${tenantId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loyalty)
      });
      alert('Programa de fidelidade atualizado!');
    } catch (e) { alert('Erro ao salvar fidelidade'); }
    setSavingLoyalty(false);
  };

  const fetchBillingStatus = async () => {
    try {
      setLoading(true);
      const res = await apiFetch(`/billing/status?tenant_id=${tenantId}`);
      const data = await res.json();
      setStatus(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const subscribe = async (plan) => {
    try {
      const res = await apiFetch(`/billing/create-checkout-session?tenant_id=${tenantId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ plan })
      });
      const data = await res.json();
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      }
    } catch (e) {
      console.error(e);
      alert('Erro ao iniciar checkout!');
    }
  };

  const fetchAgentConfig = async () => {
    try {
      const res = await apiFetch(`/api/tenants/${tenantId}/agent-config`);
      const data = await res.json();
      if (!data.error) {
        setAgentConfig(data);
      }
    } catch (e) { console.error(e); }
  };

  const saveAgentConfig = async () => {
    setSavingAgent(true);
    try {
      await apiFetch(`/api/tenants/${tenantId}/agent-config`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(agentConfig)
      });
      // Automatically reset simulator chat history to clear stale state
      try {
        await apiFetch(`/api/chats/${simPhone}/history?tenant_id=${tenantId}`, {
          method: 'DELETE'
        });
        setSimMessages([]);
      } catch (err) {
        console.error('Falha ao limpar histórico do simulador pós-salvamento:', err);
      }
      alert('Configuração do Hermes Agent salva com sucesso!');
    } catch (e) {
      alert('Erro ao salvar configuração do Hermes.');
    } finally {
      setSavingAgent(false);
    }
  };

  const fetchHandovers = async () => {
    try {
      const res = await apiFetch(`/api/chats/handover?tenant_id=${tenantId}`);
      const data = await res.json();
      if (data.active_handovers) {
        setHandovers(data.active_handovers);
      }
    } catch (e) { console.error(e); }
  };

  const toggleHandover = async (phone, active) => {
    try {
      const method = active ? 'POST' : 'DELETE';
      await apiFetch(`/api/chats/${phone}/handover?tenant_id=${tenantId}`, { method });
      fetchHandovers();
    } catch (e) { console.error(e); }
  };

  const sendSimMessage = async (e) => {
    e.preventDefault();
    if (!simInput.trim() || simLoading) return;
    
    const userMsg = simInput.trim();
    setSimInput('');
    setSimMessages(prev => [...prev, { sender: 'user', text: userMsg }]);
    setSimLoading(true);
    
    try {
      const res = await apiFetch(`/api/chats/test-message?tenant_id=${tenantId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phone: simPhone,
          message: userMsg
        })
      });
      const data = await res.json();
      if (data.reply) {
        setSimMessages(prev => [...prev, { sender: 'bot', text: data.reply }]);
      } else if (data.error) {
        setSimMessages(prev => [...prev, { sender: 'system', text: `Erro: ${data.error}` }]);
      } else {
        setSimMessages(prev => [...prev, { sender: 'system', text: 'Sem resposta do agente.' }]);
      }
    } catch (err) {
      setSimMessages(prev => [...prev, { sender: 'system', text: 'Falha na conexão com o agente.' }]);
    } finally {
      setSimLoading(false);
    }
  };

  const resetSimChat = async () => {
    if (!window.confirm("Deseja mesmo resetar a conversa do simulador? Isso limpará a memória do robô.")) return;
    try {
      await apiFetch(`/api/chats/${simPhone}/history?tenant_id=${tenantId}`, {
        method: 'DELETE'
      });
      setSimMessages([]);
      alert("Simulador reiniciado com sucesso!");
    } catch (e) {
      alert("Erro ao reiniciar simulador.");
    }
  };

  if (loading) return <div className="stat-card" style={{ padding: '2rem' }}>Carregando faturamento...</div>;

  return (
    <div className="animate-fade">
      <div className="stat-card" style={{ padding: '2rem' }}>
        <h2>Configurações da Oficina</h2>
        <p className="stat-label">Gerencie faturamento, fidelidade e inteligência artificial.</p>

        {/* AI Hermes Settings */}
        <div style={{ background: '#f8fafc', padding: '2rem', marginTop: '2rem', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h2 style={{ marginBottom: '0.5rem', color: '#6366f1', fontWeight: '800' }}>🤖 Configurações do Agente de IA (Hermes)</h2>
          <p className="stat-label">Configure a persona e as diretrizes do cérebro virtual da sua oficina.</p>

          {/* Status da Conexão WhatsApp */}
          <div style={{
            background: '#ffffff',
            padding: '1.25rem',
            marginTop: '1.5rem',
            borderRadius: '12px',
            border: '1px solid var(--border)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: 'var(--shadow-sm)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                background: agentConfig.is_active ? '#10b981' : '#64748b',
                boxShadow: agentConfig.is_active ? '0 0 8px #10b981' : 'none'
              }} />
              <div>
                <h4 style={{ margin: 0, fontWeight: '700', color: 'var(--text-primary)', fontSize: '0.95rem' }}>
                  Conexão WhatsApp (Evolution API)
                </h4>
                <p style={{ margin: 0, fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                  {agentConfig.is_active 
                    ? 'Instância pareada e ativa. IA respondendo no WhatsApp.' 
                    : 'Aguardando pareamento de QR Code via plataforma Sofia.'}
                </p>
              </div>
            </div>
            <span style={{
              background: agentConfig.is_active ? '#e6f4ea' : '#f1f3f4',
              color: agentConfig.is_active ? '#137333' : '#5f6368',
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '0.8rem',
              fontWeight: '700',
              border: agentConfig.is_active ? '1px solid #c2e7c9' : '1px solid #dadce0'
            }}>
              {agentConfig.is_active ? '● CONECTADO' : '● DESCONECTADO'}
            </span>
          </div>
          
          <div style={{ marginTop: '2.5rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>Nome do Assistente / Persona</label>
              <input 
                type="text" 
                className="input-field" 
                value={agentConfig.persona_name || ''}
                onChange={e => setAgentConfig({...agentConfig, persona_name: e.target.value})}
                style={{ width: '100%', margin: 0 }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>Chave da API de IA (Gemini/OpenAI/DeepSeek)</label>
              <input 
                type="password" 
                className="input-field" 
                value={agentConfig.ai_api_key || ''}
                onChange={e => setAgentConfig({...agentConfig, ai_api_key: e.target.value})}
                placeholder="Insira sua chave de API"
                style={{ width: '100%', margin: 0 }}
              />
            </div>
            
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>Provedor de IA Ativo</label>
              <select 
                className="input-field" 
                value={agentConfig.ai_provider || 'gemini'}
                onChange={e => setAgentConfig({...agentConfig, ai_provider: e.target.value})}
                style={{ width: '100%', margin: 0 }}
              >
                <option value="gemini">Google Gemini (2.0 Flash)</option>
                <option value="openai">OpenAI (GPT-4o-mini)</option>
                <option value="deepseek">DeepSeek (V3 Chat)</option>
              </select>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem' }}>
              <input 
                type="checkbox" 
                style={{ width: '20px', height: '20px', cursor: 'pointer', marginRight: '10px' }}
                checked={!!agentConfig.is_active} 
                onChange={e => setAgentConfig({...agentConfig, is_active: e.target.checked})}
              />
              <span style={{ fontWeight: '600', color: 'var(--text-primary)' }}>Habilitar Robô de IA</span>
            </div>
            
            <div style={{ gridColumn: 'span 2' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>Mensagem de Boas-vindas</label>
              <textarea 
                className="input-field" 
                rows="2"
                value={agentConfig.welcome_message || ''}
                onChange={e => setAgentConfig({...agentConfig, welcome_message: e.target.value})}
                style={{ width: '100%', margin: 0, fontFamily: 'inherit' }}
              />
            </div>

            <div style={{ gridColumn: 'span 2' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>Diretrizes da Persona (System Prompt)</label>
              <textarea 
                className="input-field" 
                rows="6"
                value={agentConfig.system_prompt || ''}
                onChange={e => setAgentConfig({...agentConfig, system_prompt: e.target.value})}
                style={{ width: '100%', margin: 0, fontFamily: 'inherit' }}
              />
            </div>

            <div style={{ gridColumn: 'span 2' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>Base de Conhecimento RAG (Instruções, Preços e FAQ da Oficina)</label>
              <span className="stat-label" style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                Escreva aqui as informações institucionais, regras de agendamento, preços base de serviços e perguntas frequentes. O robô usará isso como memória para tirar dúvidas dos clientes.
              </span>
              <textarea 
                className="input-field" 
                rows="6"
                value={agentConfig.rag_content || ''}
                onChange={e => setAgentConfig({...agentConfig, rag_content: e.target.value})}
                placeholder="Ex: Trocamos óleo de carros nacionais e importados. Não realizamos manutenção de câmbio automático. O alinhamento custa R$ 120 e a troca de óleo a partir de R$ 150..."
                style={{ width: '100%', margin: 0, fontFamily: 'inherit' }}
              />
            </div>
          </div>
          
          <div style={{ marginTop: '1.5rem' }}>
            <button className="btn-primary" style={{ padding: '0.75rem 2rem', background: '#6366f1', borderColor: '#6366f1' }} onClick={saveAgentConfig} disabled={savingAgent}>
              {savingAgent ? 'Salvando...' : 'Salvar Configurações do Agente'}
            </button>
          </div>

          <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid var(--border)' }} />

          <h3 style={{ marginBottom: '0.5rem', color: '#ef4444', fontWeight: '800' }}>👥 Transbordo Humano Ativo (Chats Silenciados)</h3>
          <p className="stat-label">Números de telefone em que a IA está desligada temporariamente para permitir atendimento humano.</p>
          
          {/* O transbordo é gerenciado e sincronizado a partir das configurações do Sofias */}

          {handovers.length === 0 ? (
            <p style={{ color: 'var(--text-secondary)', fontStyle: 'italic' }}>Nenhum transbordo ativo no momento. A IA está respondendo a todos os clientes.</p>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1rem' }}>
              {handovers.map(phone => (
                <div key={phone} style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: '8px', padding: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontWeight: '600' }}>📞 {phone}</span>
                  <button 
                    style={{ background: '#fee2e2', color: '#ef4444', border: 'none', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontWeight: 'bold' }}
                    onClick={() => toggleHandover(phone, false)}
                  >
                    Reativar IA
                  </button>
                </div>
              ))}
            </div>
          )}

          <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid var(--border)' }} />

          <h3 style={{ marginBottom: '0.5rem', color: '#6366f1', fontWeight: '800' }}>💬 Simulador Hermes Agent</h3>
          <p className="stat-label">Teste as respostas do seu robô em tempo real. A conversa simula o número <strong>{simPhone}</strong>.</p>
          
          <div style={{
            marginTop: '1.5rem',
            background: 'var(--bg-main)',
            border: '1px solid var(--border)',
            borderRadius: '16px',
            padding: '1.5rem',
            boxShadow: 'var(--shadow-sm)',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            maxWidth: '700px',
          }}>
            {/* Cabecalho do Chat */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid var(--border)', paddingBottom: '0.75rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span className="logo-circle" style={{ width: '36px', height: '36px', background: '#6366f1', color: '#fff', fontSize: '1rem', fontWeight: 'bold' }}>
                  {agentConfig.persona_name?.substring(0, 2).toUpperCase() || 'SO'}
                </span>
                <div>
                  <h4 style={{ margin: 0, fontWeight: '700', color: 'var(--text-primary)' }}>{agentConfig.persona_name || 'Sofia'}</h4>
                  <span style={{ fontSize: '0.75rem', color: '#10b981', fontWeight: '600' }}>● Agente Ativo</span>
                </div>
              </div>
              <button 
                className="btn-secondary" 
                onClick={resetSimChat} 
                style={{ margin: 0, padding: '5px 12px', fontSize: '0.8rem', borderColor: '#ef4444', color: '#ef4444' }}
              >
                🔄 Resetar Chat
              </button>
            </div>

            {/* Area de mensagens */}
            <div style={{
              height: '300px',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem',
              padding: '0.5rem',
              background: 'var(--bg-card)',
              borderRadius: '12px',
              border: '1px solid var(--border)',
            }}>
              {simMessages.length === 0 && (
                <div style={{ margin: 'auto', textAlign: 'center', color: 'var(--text-secondary)', fontSize: '0.9rem', maxWidth: '250px' }}>
                  <p style={{ margin: 0 }}>Nenhuma mensagem enviada.</p>
                  <p style={{ fontSize: '0.8rem', color: 'var(--text-label)', marginTop: '4px' }}>Digite algo como "Olá, meu nome é Carlos" para iniciar o diálogo.</p>
                </div>
              )}
              {simMessages.map((msg, idx) => {
                const isUser = msg.sender === 'user';
                const isSystem = msg.sender === 'system';
                
                if (isSystem) {
                  return (
                    <div key={idx} style={{ alignSelf: 'center', background: '#fee2e2', color: '#b91c1c', fontSize: '0.8rem', padding: '4px 12px', borderRadius: '20px', fontWeight: '600' }}>
                      {msg.text}
                    </div>
                  );
                }

                return (
                  <div key={idx} style={{
                    alignSelf: isUser ? 'flex-end' : 'flex-start',
                    maxWidth: '85%',
                    background: isUser ? 'linear-gradient(135deg, #6366f1, #4f46e5)' : 'var(--bg-main)',
                    color: isUser ? '#fff' : 'var(--text-primary)',
                    padding: '0.75rem 1rem',
                    borderRadius: isUser ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.04)',
                    border: isUser ? 'none' : '1px solid var(--border)',
                    fontSize: '0.95rem',
                    lineHeight: '1.4',
                    whiteSpace: 'pre-wrap',
                  }}>
                    {formatMessageText(msg.text)}
                  </div>
                );
              })}
              {simLoading && (
                <div style={{
                  alignSelf: 'flex-start',
                  background: 'var(--bg-main)',
                  border: '1px solid var(--border)',
                  padding: '0.75rem 1rem',
                  borderRadius: '16px 16px 16px 4px',
                  color: 'var(--text-secondary)',
                  fontSize: '0.9rem',
                  fontStyle: 'italic',
                }}>
                  {agentConfig.persona_name || 'Sofia'} está pensando...
                </div>
              )}
            </div>

            {/* Input Form */}
            <form onSubmit={sendSimMessage} style={{ display: 'flex', gap: '10px' }}>
              <input 
                type="text" 
                className="input-field" 
                placeholder="Digite sua mensagem de teste..."
                value={simInput}
                onChange={e => setSimInput(e.target.value)}
                style={{ flex: 1, margin: 0 }}
                disabled={simLoading}
              />
              <button 
                type="submit" 
                className="btn-primary" 
                style={{ padding: '0.75rem 1.5rem', background: '#6366f1', borderColor: '#6366f1', margin: 0 }}
                disabled={simLoading || !simInput.trim()}
              >
                Enviar
              </button>
            </form>
          </div>
        </div>

        {/* Fidelidade */}
        <div style={{ background: '#f8fafc', padding: '2rem', marginTop: '2rem', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h2 style={{ marginBottom: '0.5rem', color: '#d97706', fontWeight: '800' }}>🏆 Programa de Fidelidade (Cashback de Pontos)</h2>
          <p className="stat-label">Recompense seus clientes frequentes e incentive o retorno à oficina.</p>
          
          <div style={{ marginTop: '2.5rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>Pontos por Serviço (Troca de Óleo/Filtro)</label>
              <input 
                type="number" 
                className="input-field" 
                value={loyalty.points_per_service}
                onChange={e => setLoyalty({...loyalty, points_per_service: parseInt(e.target.value)})}
                style={{ width: '100%', margin: 0 }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>Meta para Resgate (Pontos)</label>
              <input 
                type="number" 
                className="input-field" 
                value={loyalty.points_to_reward}
                onChange={e => setLoyalty({...loyalty, points_to_reward: parseInt(e.target.value)})}
                style={{ width: '100%', margin: 0 }}
              />
            </div>
            <div style={{ gridColumn: 'span 2' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>Prêmio da Campanha (O que o cliente ganha?)</label>
              <select 
                className="input-field" 
                value={loyalty.reward_type}
                onChange={e => setLoyalty({...loyalty, reward_type: e.target.value})}
                style={{ width: '100%', margin: 0 }}
              >
                <option value="discount_5">5% de Desconto no próximo serviço</option>
                <option value="wash_free">Lavagem Completa Grátis</option>
                <option value="vitrification">Vitrificação de Parabrisa</option>
                <option value="alignment">Alinhamento e Balanceamento</option>
                <option value="inspection">Check-list de 30 itens Grátis</option>
              </select>
            </div>
          </div>
          
          <div style={{ marginTop: '2.5rem', display: 'flex', alignItems: 'center', gap: '2rem' }}>
             <button className="btn-primary" style={{ padding: '0.75rem 2rem' }} onClick={saveLoyalty} disabled={savingLoyalty}>
               {savingLoyalty ? 'Salvando...' : 'Salvar Configurações de Fidelidade'}
             </button>
             <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <input 
                  type="checkbox" 
                  style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                  checked={loyalty.is_enabled} 
                  onChange={e => setLoyalty({...loyalty, is_enabled: e.target.checked})}
                />
                <span style={{ fontWeight: '600', color: 'var(--text-primary)' }}>Habilitar Programa de Pontos</span>
             </div>
          </div>
        </div>

        <div style={{ background: '#f8fafc', padding: '2rem', marginTop: '2rem', borderRadius: '12px', border: '1px solid var(--border)' }}>
          <h3 style={{ marginBottom: '1rem', color: '#1d4ed8', fontWeight: '800' }}>Status Atual do Plano: {status?.status === 'active' ? 'ATIVO' : 'INATIVO'}</h3>
          <p style={{ fontSize: '1rem', color: 'var(--text-primary)' }}>Plano Selecionado: <strong>{status?.plan}</strong></p>
          {status?.started_at && <p className="stat-label">Iniciado em: {new Date(status.started_at).toLocaleDateString()}</p>}
          
          {status?.status !== 'active' && (
            <div style={{ marginTop: '2rem' }}>
              <p style={{ marginBottom: '1.5rem', color: 'var(--text-secondary)', fontSize: '0.95rem' }}>Sua oficina precisa de um plano ativo para continuar utilizando recursos premium como Agendamento Automático e Bots IA.</p>
              <div style={{ display: 'flex', gap: '1.5rem' }}>
                <div style={{ flex: 1, padding: '1.5rem', background: '#ffffff', borderRadius: '16px', border: '1px solid var(--border)', boxShadow: 'var(--shadow-sm)' }}>
                  <h4 style={{ color: '#64748b', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Plano Mensal</h4>
                  <h2 style={{ color: '#16a34a', margin: '1rem 0', fontSize: '2rem', fontWeight: '800' }}>R$ 150 <span style={{ fontSize: '1rem', color: '#94a3b8', fontWeight: '400' }}>/ mês</span></h2>
                  <button className="btn-primary" style={{ width: '100%', borderRadius: '10px' }} onClick={() => subscribe('premium_monthly')}>
                    Assinar Agora
                  </button>
                </div>
                <div style={{ flex: 1, padding: '1.5rem', background: '#fffbeb', borderRadius: '16px', border: '1px solid #fde68a', boxShadow: 'var(--shadow-md)' }}>
                  <h4 style={{ color: '#d97706', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Plano Anual <span style={{ background: '#fbbf24', color: '#92400e', padding: '2px 10px', borderRadius: '12px', fontSize: '0.7rem', marginLeft: '8px', fontWeight: 'bold' }}>20% OFF</span></h4>
                  <h2 style={{ color: '#16a34a', margin: '1rem 0', fontSize: '2rem', fontWeight: '800' }}>R$ 1.440 <span style={{ fontSize: '1rem', color: '#94a3b8', fontWeight: '400' }}>/ ano</span></h2>
                  <button className="btn-primary" style={{ width: '100%', background: '#d97706', border: 'none', borderRadius: '10px' }} onClick={() => subscribe('premium_yearly')}>
                    Assinar com Desconto
                  </button>
                </div>
              </div>
            </div>
          )}
          
          {status?.status === 'active' && (
            <div style={{ marginTop: '2rem' }}>
              <button className="btn-secondary" style={{ padding: '0.75rem 1.5rem' }}>
                Modificar Assinatura
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Settings;
